import { Navigate, Outlet } from 'react-router-dom';
import { useIsClient } from '@/shared/hooks/useIsClient';
import { routes } from '@/shared/config/routes';

type ClientBlockedGuardProps = {
  /** Where to send CLIENT users when they hit a blocked route. */
  redirectTo?: string;
};

/** Blocks agency CLIENT accounts from wallet / campaign-create routes. */
export function ClientBlockedGuard({
  redirectTo = routes.campaigns,
}: ClientBlockedGuardProps) {
  const isClient = useIsClient();
  if (isClient) return <Navigate to={redirectTo} replace />;
  return <Outlet />;
}
